(function () {
    var ChargingRequestCtrl = /** @class */ (function () {
        /**
         * 
         * @param $scope
         * @param $state
         * @param localStorageService
         * @param $mdDialog {$mdDialog}
         * @param $ionicScrollDelegate {$ionicScrollDelegate}
         * @param $timeout
         * @param $message {$message}
         * @param $q{angular.IQService}
         * @param $mdToast
         * @param $interpolate
         * @param $stateParams
         * @param cacheMemoryService
         * @param ChargeRequestService {ChargeRequestService}
         * @param ChargeBookingsService {ChargeBookingsService}
         * @param AuthService {AuthService}
         * @param $Loading{$Loading}
         * @param $translationService
         * @param NotificationService{NotificationService}
         * @param VehicleBookingService{VehicleBookingService}
         * @param MKioskService {MKioskService}
         * @constructor
         */
        function ChargingRequestCtrl($scope,
            $state,
            localStorageService,
            $mdDialog,
            $ionicScrollDelegate,
            $timeout,
            $message,
            $q,
            $mdToast,
            $interpolate,
            $stateParams,
            cacheMemoryService,
            ChargeRequestService,
            ChargeBookingsService,
            AuthService,
            $Loading,
            $translationService,
            NotificationService,
            VehicleBookingService,
            MKioskService) {

            this.$scope = $scope;
            this.$state = $state;
            this.localStorageService = localStorageService;
            this.$mdDialog = $mdDialog;
            this.$ionicScrollDelegate = $ionicScrollDelegate;
            this.$timeout = $timeout;
            this.$message = $message;
            this.$q = $q;
            this.$mdToast = $mdToast;
            this.$interpolate = $interpolate;
            this.$stateParams = $stateParams;
            this.cacheMemoryService = cacheMemoryService;
            this.chargeRequestService = ChargeRequestService;
            this.chargeBookingsService = ChargeBookingsService;
            this.AuthService = AuthService;            
            this.$Loading = $Loading;
            this.$translationService = $translationService;
            this.notificationService = NotificationService; // Management of notifications
            this.vehicleBookingService = VehicleBookingService;
            this.MKioskService = MKioskService;

            //@Input
            this.startTime = 8;
            this.endTime = 20;
            /** @type IVehicle[] */
            this.vehicles = [];
            /** @type IVehicle */
            this.selectedVehicle = null;
            this.connected = false;
            this.allowInputOdo = false;
            this.queued = false;
            this.loaded = false;
            this.pendingConnection = false; // NF-376
            this.$scope.vm = this;
            this.$element = angular.element("#internal-chargingrequest-page");
            this.cacheMemory = this.cacheMemoryService.get("homepage");
            this.isNightMode = false; // NF-455

            this.chargeNeededAtDepartureChanged = false; // this is to know if user changed the value on UI
            this.isAddNewCharge = false; // to know this is new charge requet, not update

            // NF-806: hide km
            this.hideAutonomyEstimation = false;

            /** @type IAuthenticatedUser */
           this.user = this.AuthService.getAuthenticatedUser();

            // init default charge request item
            /** @type IVehicle */
            this.item = {
                VehicleAutonomyOnFullCharge: 0,
                ChargeAtArrival: 0,
                ChargeNeededAtDeparture: 0,
                EstimatedCurrentCharge: 0,
                ChargingMode: 'Standard',
                AdvancedChargeNeededAtDepartureComputation: false,
                DistanceUsedToComputeChargeNeededAtDeparture: 0,
                ProposedChargeNeededAtDeparture: null,
                RequireUserToJustifyChargeRequestExceedingProposedChargeNeededAtDeparture: false,
                GreaterChargeRequestedForWorkReason: false,
                Client: null,
                GreaterChargeRequestedForPersonalReason: false,
                PersonalReason: null
            };
            
            this.isMultiSites = false; 
            this.sites = [];
            this.currentSiteId = null; // when in charge booking or queue charge, it is the current site of the booking or queue
            this.hasParkings = false;
            this.showSiteSelector = false;

            // this.vehicleId = this.$stateParams.vehicleId;
            
            this.contextId = this.$stateParams.contextId;
            /** @type {'vehiclebooking'|'vehicle'|'chargebooking'} */
            this.context = this.$stateParams.context;

            this.chargeBooking = null;
            this.hours = this.getHours();
            this.availableChargingPoints = true;
            this.queuedChargeRequests = 0;
            this.allowQueuedCharge = false;
            this.isReadOnly = true; // in case there is not charge points and also not allow to queue -> we disabled all controls
            
            this.plannedDepartureTime = 18;
            this.solarOnlyModeAvailable = false;
            this.forceSolarOnly = false;

            this.isAddNew = false; // in cluding add new charge request or new  queue charge (to control showing odo reading)            

            this.initWatch();

            // /NF-1383: in case active charge, we try to get charge request by id
            if (this.context === 'activeCharge') {
                this.chargeRequestService.get(this.contextId).then((vehicle) => {
                    vehicle.Id = this.contextId;
                    this.vehicles = [vehicle];
                    this.onInit(vehicle.Id);
                }, this.$message.error)
                .finally(this.$Loading.blockUI());
            } else {
                this.cacheMemory.getCache('vehicles', () => {
                    return this.MKioskService.getMyVehicles();
                }).then((vehicles) => {
                    if (this.context === 'vehiclebooking') {
                        // get vehicle if booking
                        this.vehicleBookingService.getVehicleForReturnedBooking(this.contextId)
                            .then((vehicle) => {
                                this.vehicles = [vehicle];
                                this.onInit(vehicle.Id);
                            }, this.$message.error)
                            .finally(this.$Loading.blockUI());
                    } else {
                        this.vehicles = vehicles;
                        this.onInit(this.contextId);
                    }
                });

            }

            
        }
        Object.defineProperty(ChargingRequestCtrl.prototype, "ChargeStatus", {
            get: function () {
                return ChargeStatus;
            },
            enumerable: true,
            configurable: true
        });


        ChargingRequestCtrl.prototype.onInit = function (contextId) {
            let self = this;
            var user = this.AuthService.getAuthenticatedUser();

            // NF-806
            if (user) {
                this.hideAutonomyEstimation = user.HideAutonomyEstimationForChargeOnMobile;
            }
            
            if (user && user.Sites) {
                this.isMultiSites = true;
                this.sites = user.Sites;
            }

            // when user come from charge request, we need to show current charge or new charge
            // NF-1383: Append one more case of activeCharge
            if (this.context === "vehicle" || this.context === "vehiclebooking" || this.context === "activeCharge") {
                if (this.vehicles.length === 0) {
                    var alert_1 = this.$mdDialog.alert()
                    .textContent(this.$translationService.getTranslation('NoElectricOrHybridVehicleAssignedToYou'))
                    .ok(this.$translationService.getTranslation('OK'))
                    .clickOutsideToClose(true);
                    this.$mdDialog.show(alert_1).then(function () {
                        self.back();
                    });

                    return;
                }

                let vehicleId = contextId;

                let vehicle = _.find(this.vehicles, function (v) { return v.Id === vehicleId });

                // console.log('----vehicle.ChargeStatus ', vehicle.ChargeStatus);

                if (!vehicle) {
                    var alert_1 = this.$mdDialog.alert()
                    .textContent(this.$translationService.getTranslation('InvalidVehicle'))
                    .ok(this.$translationService.getTranslation('OK'))
                    .clickOutsideToClose(true);
                    this.$mdDialog.show(alert_1).then(function () {
                        self.back();
                    });

                    return;
                }
                
                
                // if the vehicle in charging or in pending connect -> show again allow user to update or connect
                if (vehicle.ChargeStatus == 'Disconnected' || vehicle.ChargeStatus == null) {

                    this.isAddNew = true;
                    this.isAddNewCharge = true;
                    this.availableChargingPoints = false;
                    this.allowQueuedCharge = false;
                    this.isReadOnly = true;
                    this.initVehicleToCharge(vehicle);
                    
                    
                    if (this.isMultiSites) {
                        this.showSiteSelector = true;
                        this.restoreState();
        
                        if (!this.currentSiteId) {
                            this.currentSiteId = this.sites[0].Id;
                            this.hasParkings = this.sites[0].Parkings;
                            this.saveState();
                        } else {
                            var s = this.sites.find(s => s.Id === this.currentSiteId);
                            if (s) {
                                this.hasParkings = s.Parkings;
                            }
                        }
                    } else {
                        // in case user not in multisite any more (come from multi sites) we reset data saved before
                        this.saveState();
                    }
                    
                    this.updateQueuedChargeStatusOnSite();

                    this.computeProposedChargeNeededAtDeparture();

                    // in add new mode, we compute ProposedChargeNeededAtDeparture and use it as ChargeNeededAtDeparture
                    this.item.ChargeNeededAtDeparture = this.item.ProposedChargeNeededAtDeparture;
                } else {
                    // editing charge request
                    this.isAddNew = false;
                    this.selectedVehicle = vehicle;
                    this.item = vehicle;
                    // init user by default 
                    var user = this.AuthService.getAuthenticatedUser();
                    this.item.UserId = user.UserId;
                    this.item.UserName = user.UserName;
                    

                    
                    this.pendingConnection = vehicle.ChargeStatus == "PendingConnection";
                    this.queued = vehicle.ChargeStatus == "Queued";
                    this.connected = !this.queued && !this.pendingConnection;

                    // NF-407: if current charging point of the charge request not support solaronly then we dont allow to show selector
                    if (!this.forceSolarOnly) {
                        this.solarOnlyModeAvailable = vehicle.SupportsSolarOnly;
                    }

                    this.isReadOnly = false;

                    if (this.queued) {
                        this.currentSiteId = vehicle.SiteId;
                        this.updateQueuedChargeStatusOnSite();
                    } else {
                        this.availableChargingPoints = false;
                        this.onRender();
                    }
                }
            } else if (this.context === "chargebooking") { // when user come from charge booking screen
                let chargebookingId = contextId;
                
                let self = this;            
                this.chargeBookingsService.getChargeBooking(chargebookingId).then(function (item) {
                    self.initChargeBookingToConnect(item);
                });
            }
        };      
        ChargingRequestCtrl.prototype.showInvalidVehicleOfChargeBooking = function () {
            let self = this;
            var alert_1 = self.$mdDialog.alert()
                .textContent(this.$translationService.getTranslation('TheVehicleAssociatedToTheChargeBookingIsNotAssignedToYouAnymore'))
                .ok(this.$translationService.getTranslation('OK'))
                .clickOutsideToClose(true);
            self.$mdDialog.show(alert_1).then(function () {
                self.back();
            });
        };
        ChargingRequestCtrl.prototype.initChargeBookingToConnect = function (booking) {

            this.isAddNew = true;
            this.chargeBooking = booking;
            this.bookingId = booking.Id;

            this.currentSiteId = booking.SiteId;

            if (this.isMultiSites) {
                this.showSiteSelector = true;

                if (!this.currentSiteId) {
                    this.currentSiteId = this.sites[0].Id;
                    this.hasParkings = this.sites[0].Parkings;
                    this.saveState();
                } else {
                    var s = this.sites.find(s => s.Id === this.currentSiteId);
                    if (s) {
                        this.hasParkings = s.Parkings;
                    }
                }
            } else {
                // in case user not in multisite any more (come from multi sites) we reset data saved before
                this.saveState();
            }

            this.updateQueuedChargeStatusOnSite();

            let self = this;
            let vehicle = _.find(self.vehicles, function (v) { return v.Id === self.chargeBooking.VehicleId });

            // when cannot find the vehicle, we show the error mesage then to home screen
            if (!vehicle) {
                self.showInvalidVehicleOfChargeBooking();
                return;
            }

            self.initVehicleToCharge(vehicle);
            self.item.ChargingPointId = self.chargeBooking.ChargingPointId;
            self.item.ChargingPointName = self.chargeBooking.ChargingPointName;
            // need to overide from booking infor
            let departDate = moment(this.chargeBooking.EndDate)
            let departTime = moment(this.chargeBooking.EndTime, 'HH:mm');
            departDate.add(departTime.utc().hours(), 'hours').add(departTime.utc().minutes(), 'minutes');

            self.item.PlannedDepartureTime =  departDate.toDate();
            self.item.ChargeNeededAtDeparture = this.chargeBooking.NeededChargePercentage;
            self.onRender();
        };
        ChargingRequestCtrl.prototype.initVehicleToCharge = function (vehicle) {
            this.selectedVehicle = vehicle;

            // Start the charge request we need to transfer this value so that it ask user in case need
            this.item.UserMustProvideVehicleOdometerReading = this.selectedVehicle.UserMustProvideVehicleOdometerReading;            

            this.item.VehicleAutonomyOnFullCharge = this.selectedVehicle.VehicleAutonomyOnFullCharge;
            if (this.selectedVehicle.DefaultPlannedDepartureTime) {
                this.item.PlannedDepartureTime = this.selectedVehicle.DefaultPlannedDepartureTime;
            }

            if (this.selectedVehicle.DefaultChargeNeededAtDeparture) {
                this.item.ChargeNeededAtDeparture = this.selectedVehicle.DefaultChargeNeededAtDeparture;
            }

            this.item.AdvancedChargeNeededAtDepartureComputation = this.selectedVehicle.AdvancedChargeNeededAtDepartureComputation;
            this.item.DistanceUsedToComputeChargeNeededAtDeparture = this.selectedVehicle.DistanceUsedToComputeChargeNeededAtDeparture;
            this.item.ProposedChargeNeededAtDeparture = this.selectedVehicle.ProposedChargeNeededAtDeparture;
            this.item.RequireUserToJustifyChargeRequestExceedingProposedChargeNeededAtDeparture = this.selectedVehicle.RequireUserToJustifyChargeRequestExceedingProposedChargeNeededAtDeparture;
            this.item.GreaterChargeRequestedForWorkReason = this.selectedVehicle.GreaterChargeRequestedForWorkReason;
            this.item.Client = this.selectedVehicle.Client;
            this.item.GreaterChargeRequestedForPersonalReason = this.selectedVehicle.GreaterChargeRequestedForPersonalReason;
            this.item.PersonalReason = this.selectedVehicle.PersonalReason;
        };
      
        ChargingRequestCtrl.prototype.onRender = function () {
            var _this = this;
            if (this.item.PlannedDepartureTime) {
                var departDateTime = this.item.PlannedDepartureTime;
                // console.log('render item ', this.item);
                this.plannedDepartureTime = moment(departDateTime).hour() + moment(departDateTime).minute() / 60;                

                // apply night mode
                var departTime  = moment(departDateTime).hour() + moment(departDateTime).minute() / 60;
                // console.log('-----departTime = ', departTime);

                if (departTime > 20 || departTime < 8) {
                    this.isNightMode = true;
                    this.updateTimeRange(); 

                    // next day
                    if(departTime < 8) {
                        this.plannedDepartureTime = 24 + departTime;
                    }
                } 
            }
            
            this.allowInputOdo = this.isAddNew && ['Mandatory', 'Optional'].indexOf(this.item.UserMustProvideVehicleOdometerReading) >= 0;

            this.loaded = true;
            //Prevent scroll when slide slider
            this.$timeout(function () {
                _this.preventScroll(_this.$element.find("md-slider"));
            }, 100);
        };
        /**
         * Get hours
         */
        ChargingRequestCtrl.prototype.getHours = function () {
            var hours = [];
            this.strStartTime = moment(moment().format("YYYY-MM-DD")).add(this.startTime, "hours").format("HH:mm");
            // NF-455: with night mode we need to become of next day
            this.strEndTime = moment(moment().format("YYYY-MM-DD")).add(this.isNightMode ? 8 : this.endTime, "hours").format("HH:mm");
            // old code before night mode
            // for (var i = this.startTime + 1; i < this.endTime; i = i + 1) {
            //     var label = "";
            //     if (i == 12)
            //         label = moment(moment().format("YYYY-MM-DD")).add(i, "hours").format("HH");
            //     hours.push({
            //         label: label,
            //         left: (i - this.startTime) / (this.endTime - this.startTime) * 100
            //     });
            // }

            // NF-455: with night mode, we just with each block of 12 hours
            for (var i = 0; i < 12; i++) {
                var label = "";

                // 12PM or 0AM
                if (i == 4) {
                    label = moment(moment().format("YYYY-MM-DD")).add(i + this.startTime, "hours").format("HH:mm");
                }

                hours.push({
                    label: label,
                    left: i * (100 / 12)
                });
            }

            return hours;
        };
        /**
         * Prevent scroll when slide
         * @param element
         */
        ChargingRequestCtrl.prototype.preventScroll = function (element) {
            var _this = this;
            element.on("touchstart mousedown", function () {
                _this.$ionicScrollDelegate.freezeAllScrolls(true);
            });
            element.on("touchend mouseup", function () {
                _this.$ionicScrollDelegate.freezeAllScrolls(false);
            });
        };
        ChargingRequestCtrl.prototype.computeProposedChargeNeededAtDeparture = function() {
            // NF-669
            var proposedChargeNeededAtDeparture = 0;
            if (this.item.AdvancedChargeNeededAtDepartureComputation &&
                this.item.DistanceUsedToComputeChargeNeededAtDeparture > 0 &&
                this.item.VehicleAutonomyOnFullCharge > 0) {

                if (this.item.DistanceUsedToComputeChargeNeededAtDeparture > this.item.VehicleAutonomyOnFullCharge) {
                    proposedChargeNeededAtDeparture = 100;
                } else {
                    var proposedChargeNeededAtDeparture =  this.item.DistanceUsedToComputeChargeNeededAtDeparture / this.item.VehicleAutonomyOnFullCharge * 100;

                    if (proposedChargeNeededAtDeparture > 0) {
                        proposedChargeNeededAtDeparture = Math.round(proposedChargeNeededAtDeparture + 0.5); // + 0.5 is for round up
                    }
    
                    // console.log('% proposedChargeNeededAtDeparture ', proposedChargeNeededAtDeparture);
                    if (proposedChargeNeededAtDeparture < this.item.ChargeAtArrival) {
                        proposedChargeNeededAtDeparture = this.item.ChargeAtArrival;
                    }
                }
                // proposedChargeNeededAtDeparture in %
            }

            this.item.ProposedChargeNeededAtDeparture = proposedChargeNeededAtDeparture;
        }

        ChargingRequestCtrl.prototype.onChargeNeededAtDepartureChange = function () {            
            this.chargeNeededAtDepartureChanged = true;
        };
        ChargingRequestCtrl.prototype.initWatch = function () {
            var _this = this;
            this.$scope.$watch("vm.item.ChargeAtArrival", function (currentCharge) {
                _this.chargeAtArrivalKM = Math.round((currentCharge / 100) * _this.item.VehicleAutonomyOnFullCharge);

                // NF-157: idea remove the restriction of not allow set power needed in case charge booking activated 
                // if (_this.chargeBooking) {
                //     _this.item.ChargeNeededAtDeparture = currentCharge + _this.chargeBooking.NeededChargePercentage;
                //     if (_this.item.ChargeNeededAtDeparture > 100) { _this.item.ChargeNeededAtDeparture = 100; }
                // }
            });
            this.$scope.$watch("vm.item.ChargeNeededAtDeparture", function (requestedCharge) {
                _this.chargeNeededAtDepartureKM = Math.round((requestedCharge / 100) * _this.item.VehicleAutonomyOnFullCharge);
          
            });
            this.$scope.$watch("vm.item.EstimatedCurrentCharge", function (charged) {
                _this.estimatedCurrentChargeKM = Math.round((charged / 100) * _this.item.VehicleAutonomyOnFullCharge);
            });
            //Update chargeAtArrivalKM,chargeNeededAtDepartureKM,estimatedCurrentChargeKM when VehicleAutonomyOnFullCharge changed
            this.$scope.$watch("vm.item.VehicleAutonomyOnFullCharge", function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    _this.chargeAtArrivalKM = Math.round((_this.item.ChargeAtArrival / 100) * newValue);
                    _this.chargeNeededAtDepartureKM = Math.round((_this.item.ChargeNeededAtDeparture / 100) * newValue);
                    _this.estimatedCurrentChargeKM = Math.round((_this.item.EstimatedCurrentCharge / 100) * newValue);
                }
            });
            this.$scope.$watch("vm.plannedDepartureTime", function (plannedDepartureTime) {
                // console.log('---plannedDepartureTime changed to ', plannedDepartureTime);
                // old way before night mode
                // _this.departureTimePercent = (plannedDepartureTime - _this.startTime) / (_this.endTime - _this.startTime) * 100;
                _this.departureTimePercent = (plannedDepartureTime - _this.startTime) * (100 / 12);
                _this.departureTimeHour = moment(moment().format("YYYY-MM-DD")).add(plannedDepartureTime, "hours").format("HH:mm");
            });
        };
        /**
         * Show messaage when disconnected
         * @param ev
         * @returns {angular.IPromise<any>}
         */
        ChargingRequestCtrl.prototype.showConfirmMarkAsFreeMessage = function (ev) {
            let msg = this.$message.get('ConfirmMarkAsFree');
            var alert = this.$mdDialog.confirm()
                .theme('custom-confirm')
                .htmlContent(msg)
                .ok(this.$translationService.getTranslation('Yes'))
                .cancel(this.$translationService.getTranslation('No'))          
                .targetEvent(ev)
                .clickOutsideToClose(false)
                .escapeToClose(false);
            return this.$mdDialog.show(alert);
        };

        /**
         * Show messaage when dequeue
         * @param ev
         * @returns {angular.IPromise<any>}
         */
        ChargingRequestCtrl.prototype.showDeQueuedMessage = function (ev) {            
            let msg = this.$translationService.getTranslation('YourQueuedChargeRequestHasBeenDeleted');
            var alert = this.$mdDialog.alert()
                // .textContent('Your queued charge request has been deleted.')
                .textContent(msg)
                .ok(this.$translationService.getTranslation('OK'))
                .targetEvent(ev)
                .clickOutsideToClose(true);
            return this.$mdDialog.show(alert);
        };
        /**
         * Show thank  message
         * @param ev
         * @returns {angular.IPromise<any>}
         */
        ChargingRequestCtrl.prototype.showThanksMessage = function (ev) {
            let msg = this.$translationService.formatTranslation('YourChargingRequestHasBeenRecorded', this.item.UserName); 
            
            var alert = this.$mdDialog.alert()
                //.textContent('Thank you ' + this.item.UserName + '. Your charging request has been recorded')
                .textContent(msg)
                .ok(this.$translationService.getTranslation('OK'))
                .targetEvent(ev)
                .clickOutsideToClose(true);
            return this.$mdDialog.show(alert);
        };
        ChargingRequestCtrl.prototype.showTheVehicleOfThisUserIsNotConnected = function (ev) {
            let msg = this.$translationService.getTranslation('ThisChargeRequestHasAlreadyEnded');

            var alert = this.$mdDialog.alert()
                // .htmlContent('This charge request has already ended.</br></br>Please check the current charge status of your vehicle, and perform a new charge request if needed.')
                .htmlContent(msg)
                .ok(this.$translationService.getTranslation('OK'))
                .targetEvent(ev)
                .clickOutsideToClose(true);
            return this.$mdDialog.show(alert);
        };
        ChargingRequestCtrl.prototype.onConnectMonta = function (ev) {
            var _this = this;
            // NF-NF-1377: Manage Monta control mode, we dont show details of request, so we dont need to check Odo reading
            if (this.item.ChargingMode === 'Monta') {
                var user = this.AuthService.getAuthenticatedUser();

                 this.$mdDialog.show({
                    controller: 'MontaChargeRequestCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'js/internal/chargingrequest/monta-charge-request/monta-charge-request.view.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: false,
                    locals: {
                        chargingPointId: this.item.ChargingPointId,
                        userId: user.UserId,
                        vehicleId: this.selectedVehicle.Id,
                        chargeSessionId: '',
                        initAction: 'connect'
                    }
                }).then(function (answer) {
                    if (answer == true) {
                        _this.gotoHomePage();
                    }
                });

                return false;
            }
        }
        /**
         * Submit
         * @param ev
         * @returns {boolean}
         */
        ChargingRequestCtrl.prototype.onSaveClick = function (ev) {
            var _this = this;
            if (!this.item.ChargingPointId && this.availableChargingPoints) {
                let msg = this.$translationService.getTranslation('PleaseSelectChargingStation');
                
                var toast = this.$mdToast.simple()
                    // .textContent('Please select charging station.')
                    .textContent(msg)
                    .position("top right")
                    .hideDelay(4000);
                this.$mdToast.show(toast);
                var scrollView = this.getScrollerDelegate().getScrollView();
                scrollView.scrollTo(0, 0);
                return false;
            }
            // NF-575: if the new value is mandatory we show error so that ask user must input odo
            if (this.allowInputOdo && !this.connected && !this.item.OdometerReading) {
                if (this.item.UserMustProvideVehicleOdometerReading == 'Mandatory') {
                    let msg = this.$translationService.getTranslation('PlsInputVehicleMileage');
                    var toast = this.$mdToast.simple()
                        .textContent(msg)
                        .position("top right")
                        .hideDelay(4000);
                    this.$mdToast.show(toast);
                    var scrollView = this.getScrollerDelegate().getScrollView();
                    scrollView.scrollTo(0, 0);
                    return false;
                }

                // NF-575: if the new value is optional we showe error so that ask user must input odo
                if (this.item.UserMustProvideVehicleOdometerReading == 'Optional') {
                    let title = this.$translationService.getTranslation('PlsInputVehicleMileage');
                    let msg = this.$translationService.getTranslation('ExplainCanInputVehicleMileageNextTime');
                    
                    var confirm_1 = this.$mdDialog.confirm()
                        // .title('Please input the vehicle mileage')
                        // .textContent("You can skip the input the vehicle mileage if you did not check the vehicle odometer reading, in which case the application will ask you again next time you connect this vehicle.")
                        .title(title)
                        .textContent(msg)
                        .theme('custom-confirm')
                        .ok(this.$translationService.getTranslation('OK'))
                        .cancel(this.$translationService.getTranslation('SkipAndContinue'));
                    
                    this.$mdDialog.show(confirm_1).then(function () {
                        _this.$element.find(".input-odometer-reading").addClass("form-control-submited");
                        _this.$element.find(".input-odometer-reading")[0].focus();
                    }, function () {
                        _this.item.SkipInputOfOdometerReading = true; // Skip save OdometerReading
                        if(_this.isNeedJustify()){
                            _this.showAndSaveJustifyReasonModal(ev);
                        } else {
                            _this.save(ev);
                        }
                    });
                    return false;
                }
            }

            // NF-669: asking for justify reason when user need more than computed
            if (this.isNeedJustify()) {
                this.showAndSaveJustifyReasonModal(ev);
                return false; 
            }
            
            this.$timeout(function () {
                _this.save(ev);
            }, 500);
        };

        /**
         * Checking show if user need to justify reason
         * @returns {boolean}
         */
        ChargingRequestCtrl.prototype.isNeedJustify = function() {
            // NF-669: asking for justify reason when user need more than computed
            return ((this.isAddNewCharge || this.chargeNeededAtDepartureChanged) &&
                this.item.RequireUserToJustifyChargeRequestExceedingProposedChargeNeededAtDeparture &&
                this.item.ProposedChargeNeededAtDeparture > 0 &&
                this.item.ChargeNeededAtDeparture > this.item.ProposedChargeNeededAtDeparture);
        }

        /**
         * Show justify reason modal and save
         * @param ev{MouseEvent}
         */
        ChargingRequestCtrl.prototype.showAndSaveJustifyReasonModal = function (ev) {
            var _this = this;
            this.showJustifyReasonModal(ev).then(function (justify) {
                if (justify) {
                    // Reset before save justify reason
                    _this.item.GreaterChargeRequestedForPersonalReason = false;
                    _this.item.PersonalReason = null;
                    _this.item.GreaterChargeRequestedForWorkReason = true;
                    _this.item.Client  = null;

                    if (justify.reason === 'personal') {
                        _this.item.GreaterChargeRequestedForPersonalReason = true;
                        _this.item.PersonalReason = justify.personalReason;
                    }

                    if (justify.reason === 'work') {
                        _this.item.GreaterChargeRequestedForWorkReason = true;
                        _this.item.Client  = justify.client;
                    }

                    _this.save(ev);
                }
            });
        }

        ChargingRequestCtrl.prototype.showJustifyReasonModal = function ($event) {
            var _self = this;

            return this.$mdDialog.show({
                controller: 'JustifyReasonModalCtrl',
                controllerAs: 'vm',
                templateUrl: 'js/shared/justify-reason-modal/justify-reason-modal.view.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                fullscreen: false,
                escapeToClose: false,
                clickOutsideToClose: false,
                locals: {
                    kmPerDay: this.item.DistanceUsedToComputeChargeNeededAtDeparture
                }
            });            
        }
        /**
         * Prepare data
         * @returns {any}
         */
        ChargingRequestCtrl.prototype.prepareDataToSave = function () {
            var data = this.item;
            // Update OdometerReading if OdometerReading>0

            //Connect vehicle which was charging by other user
            if (this.connected && data.ChargedByAnotherUser) {
                data.DisconnectCurrentChargingByOtherUser = true;
            }
            
            data.PlannedDepartureTime = moment().hours(0).minutes(0).seconds(0).add(this.plannedDepartureTime, "hours").utc().format();            

            // NF-157
            if (this.bookingId) {
                data.ChargeBookingId = this.bookingId;
            }

            if (data.ChargingMode === 'SolarOnly') {
                delete data.PlannedDepartureTime;
                delete data.ChargeAtArrival;
                delete data.ChargeNeededAtDeparture;
            }

            return data;
        };
        /**
         * Save
         * @param ev {MouseEvent}
         */
        ChargingRequestCtrl.prototype.save = function (ev) {
            var _this = this;
            var tosave = _this.prepareDataToSave()
            if (!tosave.UserId) {
                var user = this.AuthService.getAuthenticatedUser();
                tosave.UserId = user.UserId;
                tosave.UserName = user.UserName;
            }
            if (!tosave.VehicleId && _this.selectedVehicle) {
                tosave.VehicleId = _this.selectedVehicle.Id;
            }
            //
            if (this.connected || this.pendingConnection || // Update charge request
                (this.queued && this.item.Id && !this.availableChargingPoints)) { //NF-1083: Problem 4, Update queue charge request
                this.$Loading.show();
                this.chargeRequestService.update(tosave).then(function (result) {
                    if (result) {
                        _this.item = result;
                    }

                    _this.showThanksMessage(ev).finally(function () {
                        _this.gotoHomePage(true);
                    });
                }, function (error) {
                    _this.showConnectErrorMessage(error);
                }).finally(function () {
                    _this.$Loading.hide();
                });
            } else { // Connect if have charge point or add to Queue if have no charge point
                if(this.context === 'vehiclebooking' ){
                    // Only send ChargeMadeUponReturnOfVehicleBookingId when charge other vehicles
                    // Add vehicleBookingId if charge request come from vehiclebooking
                    tosave.ChargeMadeUponReturnOfVehicleBookingId = this.contextId;
                }

                if (this.availableChargingPoints) { // Connect
                    this.$Loading.show();
                    this.chargeRequestService.connect(tosave).then(function (result) {
                        _this.showThanksMessage(ev).finally(function () {
                            _this.gotoHomePage(true);
                        });
                    }, function (error) {
                        _this.showConnectErrorMessage(error);
                    }).finally(function () {
                        _this.$Loading.hide();
                    });
                } else { //Create a Queue
                    if (_this.allowQueuedCharge) {
                        this.$Loading.show();

                        tosave.SiteId = this.currentSiteId;
                        // in case there is no charge point available, we need to save in queue
                        this.chargeRequestService.queueChargeRequest(tosave).then(function (result) {
                            _this.showThanksMessage(ev).finally(function () {
                                _this.gotoHomePage(true);
                            });
                        }, function (error) {
                            _this.showConnectErrorMessage(error);
                        }).finally(function () {
                            _this.$Loading.hide();
                        });
                        
                    } else {
                        _this.isReadOnly = true;
                    }
                }

            }
        };

        /**
         * Show charging point
         * @param ev
         */
        ChargingRequestCtrl.prototype.showParkingAreaPopup = function (ev) {
            var _this = this;
            
            this.$mdDialog.show({
                controller: 'ParkingAreaCtrl',
                templateUrl: 'js/internal/parkingarea/parkingarea.view.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    vehiclestatus: this.item,
                    useBooking: this.chargeBooking,
                    siteId: this.currentSiteId,
                    hasParkings: this.hasParkings
                }
            }).then(function (answer) {
                if (answer == 'NoChargingPointAvailable') { // NF-1165: Show queue charge request when user select no charging point
                    _this.availableChargingPoints = false;
                    answer = {
                        SupportsSolarOnly: false,
                        ChargingPointId: null,
                        ChargingPointName: null
                    };
                }
                _this.item.ChargingPointId = answer.ChargingPointId;
                _this.item.ChargingPointName = answer.ChargingPointName;
                
                // in case driver not force solar only mode, we need to show mode selection when the charging point support solar only
                if (!_this.forceSolarOnly) {
                    _this.solarOnlyModeAvailable = answer.SupportsSolarOnly;

                    // when the charging point is not for solaronly and this user not force to, we can auto change the mode
                    if (!_this.solarOnlyModeAvailable) {
                        _this.item.ChargingMode = 'Standard';
                    }
                }

                // NF-1377: ControlMode = Monta, we dont show details of request
                if (answer.ControlMode === 'Monta') {
                    _this.solarOnlyModeAvailable = false;
                    _this.item.ChargingMode = 'Monta';
                }

            });
        };
        ChargingRequestCtrl.prototype.onDisconnectMonta = function (ev) {
            // NF-1383: for Monta, need to show another message box like progress
            var _this = this;
            if (this.item.ChargingMode == 'Monta') {
                 var user = this.AuthService.getAuthenticatedUser();

                 this.$mdDialog.show({
                    controller: 'MontaChargeRequestCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'js/internal/chargingrequest/monta-charge-request/monta-charge-request.view.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: false,
                    locals: {
                        chargingPointId: this.item.ChargingPointId,
                        userId: user.UserId,
                        vehicleId: '',
                        chargeSessionId: this.item.ActiveChargingSessionId,
                        initAction: 'disconnect'
                    }
                }).then(function (answer) {
                    if (answer == true) {
                        _this.gotoHomePage();
                    }
                });


            }
        }
        /**
         * Disconnect charge
         * @param ev
         */
        ChargingRequestCtrl.prototype.disconnect = function (ev) {
            var _this = this;

            var disconnect = (markAsFree) => {
                this.performDisconnect(ev, markAsFree)
                    .then(() => {
                        this.back();
                    },  this.$message.error)
                    .finally(this.$Loading.blockUI());
            }

            this.showConfirmMarkAsFreeMessage(ev).then(function () {
               disconnect(true);
            }, function () {
               disconnect(false);
            });
           
        };

        /**
         * Performs a disconnect operation for a charging request
         * @param {MouseEvent} ev - The mouse event that triggered the disconnect
         * @param {boolean} [markasfree=false] - Flag indicating whether to mark the charging point as free
         * @returns {Promise} Promise that resolves when disconnect is complete
         */
        ChargingRequestCtrl.prototype.performDisconnect = function (ev, markasfree = false) {
            var data = {
                Id: this.item.ActiveChargingSessionId,
                UserId: this.item.UserId,
                ChargingPointId: this.item.ChargingPointId,
                ChargingPointIsNowFree: markasfree
            };
            return this.chargeRequestService.disconnect(data);
        };

        ChargingRequestCtrl.prototype.onDeQueueClick = function (ev) {
            var tosave = this.prepareDataToSave();
            
            if (!tosave.VehicleId && this.selectedVehicle) {
                tosave.VehicleId = this.selectedVehicle.Id;
            }

            // Show confirm before DeQueue
            this.showConfirmDeQueueMessage(ev).then(() => {
                // DeQueue
                this.chargeRequestService.deQueueChargeRequest(tosave)
                    .then(() => {
                        // Show message after DeQueue
                        this.showDeQueuedMessage(ev).finally(() => {
                            this.back();
                        });
                    }, this.$message.error)
                    .finally(this.$Loading.blockUI());
            });
        };


        /**
         * Navigate back to previous screen
         * @param hasChange {boolean} - Flag indicating whether notification should be closed
         */
        ChargingRequestCtrl.prototype.back = function (hasChange) {
            // If there is an urgent notification to connect to charging point
            if (this.notificationService.currentNotificationUrgent && this.notificationService.currentNotificationUrgent.Type === 'ConnectToChargingPoint') {
                if (hasChange) {
                    // have to close the urgent notification, to can check next urgent notification
                    this.notificationService.isCheckingUrgentNotifications = false;
                    // Close all urgent notifications and go to home page
                    this.notificationService.closeAllDialogUrgent().finally(() => {
                        this.$state.go('internal.home');
                    });
                    return;
                } else { // press on cancel then show the urgent notification again
                    // Show the urgent notification again
                    this.notificationService.currentDialogUrgentRef.show();
                }
            }

            let stateName = 'internal.home';
            let params = {};

            if (this.context === 'vehiclebooking'  && this.$stateParams.state) { // Click on back button in the header and Screen come 'vehiclebooking'
                let state = JSON.parse(this.$stateParams.state) || {};
                if (state.stateName) {
                    stateName = state.stateName;
                }
                if (state.scrollTop) {
                    params.scrollTop = state.scrollTop;
                }
            }

            // Default behavior - go to home page
            this.$state.go(stateName, params);
        };
        
        ChargingRequestCtrl.prototype.getScrollerDelegate = function () {
            return this.$ionicScrollDelegate.$getByHandle("chargingrequest-scoller-handle");
        };

        ChargingRequestCtrl.prototype.gotoHomePage = function (result) {
            this.back(result);
        };

        /**
         * Handle error when connect charge
         * @param error
         * return {void}
         */
        ChargingRequestCtrl.prototype.showConnectErrorMessage = function (error) {
            if(error && error.data && error.data.code && error.data.code === 'TheVehicleOfThisUserIsNotConnectedToThisChargingPoint'){
                 this.showTheVehicleOfThisUserIsNotConnected().finally(() => {
                    this.gotoHomePage();
                });
            } else {
                 this.chargeRequestService.handleOdometerReadingError(error).then(()=>{
                    this.item.BypassValidationOfOdometerReading = true;
                    this.save();
                });
            }
        };
        /**
         * Increase NeedPower to max
         */
        ChargingRequestCtrl.prototype.increaseToMax = function () {
            this.item.ChargeNeededAtDeparture = 100;
        };        
        ChargingRequestCtrl.prototype.onSiteChanged = function () {
            this.saveState();

            this.item.ChargingPointId = null;
            this.item.ChargingPointName = null;
            this.updateQueuedChargeStatusOnSite();

            // NF-811: update hasParking flag in case site changed
            let self = this;
            let currentSite = _.find(this.sites, function (v) { return v.Id === self.currentSiteId });

            if (currentSite) {
                this.hasParkings = currentSite.Parkings;
            } else {
                this.hasParkings = false;
            }
        },
        /**
         * This method to update if the current site allow do queued charge and also if the site with available charging point to charge
        */
        ChargingRequestCtrl.prototype.updateQueuedChargeStatusOnSite = function() {            
            this.allowQueuedCharge = false;
            if (this.currentSiteId) {
                let self = this;
                let currentSite = _.find(this.sites, function (v) { return v.Id === self.currentSiteId });

                if (currentSite) {

                    // NF-767: from this issue we change this logic
                    // let queuedVehicle = _.find(this.vehicles, function(v) { return v.ChargeStatus === "Queued"; });
                    // // we allow only 1 queued vehicle for a driver then if the driver has been queued by other vehilce then we dont allow make a queue
                    // if (queuedVehicle && queuedVehicle.Id !== this.selectedVehicle.Id) {
                    //     this.allowQueuedCharge = false;
                    // } else {
                    //     this.allowQueuedCharge = currentSite.QueuedChargeRequestEnabled;
                    // }

                    // NF-767: Cja notify that we can have more than 1 vehicles queued, so we if the site allow queue then we allow
                    this.allowQueuedCharge = currentSite.QueuedChargeRequestEnabled;

                    this.chargeRequestService.getAvailableChargingPoints(self.currentSiteId).then(x => {
                        self.availableChargingPoints = x.AvailableChargingPoints;
                        self.queuedChargeRequests = x.QueuedChargeRequests;

                        self.isReadOnly = !self.availableChargingPoints && !this.allowQueuedCharge;
                        self.onRender();
                    });
                }
            } else {                
                this.onRender();
            }
        };
        ChargingRequestCtrl.prototype.saveState = function () {
            let state = {
                currentSiteId: this.currentSiteId
            }
            this.localStorageService.set("charge-request", state);            
        };
        ChargingRequestCtrl.prototype.restoreState = function () {
            let state = this.localStorageService.get("charge-request");
            if (state) {
                this.currentSiteId = state.currentSiteId;
                if (this.sites) {
                    let index = this.sites.findIndex(x => x.Id === this.currentSiteId);                    

                    // in case the save site is not available anymore, we dont try to restore it
                    if (index < 0) {
                        this.currentSiteId = null;
                    }
                }
            } else {
                this.currentSiteId = null;
            }
        };
        ChargingRequestCtrl.prototype.updateTimeRange = function(value) {
            if (this.isNightMode) {
                this.startTime = 20;
                this.endTime = 8;
            } else {
                this.startTime = 8;
                this.endTime = 20;
            }
            this.hours = this.getHours();
        };
        ChargingRequestCtrl.prototype.nightModeChanged = function(value) {
            
            this.updateTimeRange();
            // this cheat due to stupid slider control not refresh properly
            setTimeout(() => {
                this.plannedDepartureTime = this.startTime;
                this.safeApply();
                // this.$scope.$digest();
            }, 10);
        };
        ChargingRequestCtrl.prototype.safeApply = function (fn) {
            var phase = this.$scope.$root.$$phase;
            if (phase == '$apply' || phase == '$digest') {
                if (fn && (typeof(fn) === 'function')) {
                    fn();
                }
            } else {
                this.$scope.$apply(fn);
            }
        };        

        /**
         * Show messaage when disconnected
         * @param ev
         * @returns {angular.IPromise<any>}
         */
        ChargingRequestCtrl.prototype.showConfirmDeQueueMessage = function (ev) {
            let msg = this.$message.get('DeleteQueueChargeBody');
            let title = this.$message.get('DeleteQueueChargeTitle');
            var alert = this.$mdDialog.confirm()
                .theme('custom-confirm')
                .htmlContent(msg)
                .title(title)
                .ok(this.$translationService.getTranslation('Yes'))
                .cancel(this.$translationService.getTranslation('No'))
                .targetEvent(ev)
                .clickOutsideToClose(false)
                .escapeToClose(false);
            return this.$mdDialog.show(alert);
        };


        /**
         * Trigger when click Cancel button. 
         * if pendingConnection show confirm dialog
         *    + Yes, disconnect, go home screen
         *    + No, do nothing
         * otherwise, call back default 
         * @param ev {MouseEvent}
         */
        ChargingRequestCtrl.prototype.onCancel = function(ev){
            if (this.pendingConnection) {
                this.showConfirmCancelRequest(ev).then(() => {
                    this.performDisconnect(ev, true)
                        .then(() => {
                            this.back(true);
                        })
                        .finally(this.$Loading.blockUI());
                });
            } else {
                this.back();
            }
        }

        /**
         * Show confirm cancel request
         * @param ev {MouseEvent}
         * @returns {Promise<*>}
         */
        ChargingRequestCtrl.prototype.showConfirmCancelRequest = function (ev) {
            let msg = this.$message.get('CancelQueueCharge');
            let alert = this.$mdDialog.confirm()
                .theme('custom-confirm')
                .htmlContent(msg)
                .ok(this.$translationService.getTranslation('Yes'))
                .cancel(this.$translationService.getTranslation('No'))
                .targetEvent(ev)
                .clickOutsideToClose(false)
                .escapeToClose(false);
            return this.$mdDialog.show(alert);
        }



        
        ChargingRequestCtrl.$inject = ['$scope',
            '$state',
            'localStorageService',
            '$mdDialog',
            '$ionicScrollDelegate',
            '$timeout',
            '$message',
            '$q',
            '$mdToast',
            '$interpolate',
            '$stateParams',
            'CacheMemoryService',
            'ChargeRequestService',
            'ChargeBookingsService',
            'AuthService',
            '$Loading',
            '$translationService',
            'NotificationService',
            'VehicleBookingService',
            'MKioskService'
        ];
        return ChargingRequestCtrl;
    }());
    angular.module('internal.chargingrequest').controller('ChargingRequestCtrl', ChargingRequestCtrl);
})();
